module.exports = __webpack_public_path__ + "img/イノフェス_talksession_nft_企画書_ページ_5.dc705d07.png";